var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFunction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8522 9.983L18.0697 3.78213C18.1925 3.63904 18.2567 3.45497 18.2494 3.26672C18.2421 3.07847 18.1639 2.8999 18.0303 2.76668C17.8968 2.63347 17.7177 2.55543 17.5289 2.54816C17.3402 2.54088 17.1556 2.60492 17.0122 2.72746L10.7947 8.92833L4.57716 2.71998C4.43593 2.57913 4.24438 2.5 4.04466 2.5C3.84493 2.5 3.65339 2.57913 3.51216 2.71998C3.37093 2.86083 3.29159 3.05186 3.29159 3.25105C3.29159 3.45025 3.37093 3.64128 3.51216 3.78213L9.73716 9.983L3.51216 16.1839C3.43365 16.2509 3.36988 16.3334 3.32486 16.4262C3.27985 16.519 3.25455 16.6201 3.25056 16.7231C3.24657 16.8261 3.26397 16.9289 3.30168 17.0249C3.33939 17.1208 3.39658 17.208 3.46967 17.2809C3.54276 17.3538 3.63017 17.4109 3.72642 17.4485C3.82266 17.4861 3.92566 17.5034 4.02895 17.4994C4.13224 17.4955 4.23359 17.4702 4.32664 17.4253C4.41968 17.3804 4.50242 17.3168 4.56966 17.2385L10.7947 11.0377L17.0122 17.2385C17.1556 17.3611 17.3402 17.4251 17.5289 17.4178C17.7177 17.4106 17.8968 17.3325 18.0303 17.1993C18.1639 17.0661 18.2421 16.8875 18.2494 16.6993C18.2567 16.511 18.1925 16.327 18.0697 16.1839L11.8522 9.983Z",
    fill: "#1A141F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFunction);
export default __webpack_public_path__ + "static/media/deleteFunction.4e33fb1a4a37a471710e4621fb4c5aa9.svg";
export { ForwardRef as ReactComponent };